// extracted by mini-css-extract-plugin
export var description = "PartnerProgramsIntro-module__description___epUsi";
export var section = "PartnerProgramsIntro-module__section___rHhL3";
export var title = "PartnerProgramsIntro-module__title___dmaMa";